require('./vendor-login');  //FIXME try to modularize this so we can include it in the index instead of here.
/*
 * Dependencies: internal files.
 */
/* Login App JS */
require('./WebContent/src/login/login.js');
/* html files. */
var htmlRequireContext = require.context('./WebContent/src', true, /\.html$/);
htmlRequireContext.keys().forEach(htmlRequireContext);


// WEBPACK FOOTER //
// ./app-login.js